import { render, staticRenderFns } from "./RecursosHumanos.vue?vue&type=template&id=3d673056&scoped=true"
import script from "./RecursosHumanos.vue?vue&type=script&lang=js"
export * from "./RecursosHumanos.vue?vue&type=script&lang=js"
import style0 from "./RecursosHumanos.vue?vue&type=style&index=0&id=3d673056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d673056",
  null
  
)

export default component.exports